import { transformCompactToBooleanFilter } from '@/common/utils/compact-filters/transformCompactFilters';
import { getBooleanValue } from '@/common/utils/filters/filterValueExtractors';

export const isShowArchivedOn = (showArchived: string | undefined): boolean =>
  getBooleanValue(transformCompactToBooleanFilter(showArchived)) === true;
